import React, { createContext, useContext, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

const LoaderCtx = createContext(null);
export const useLoader = () => useContext(LoaderCtx);

const TIPS = {
  histoire: [
    "Une bonne histoire commence par une émotion, pas par une intrigue.",
    "Ton personnage veut quelque chose — l'obstacle crée le récit.",
    "Écris d'abord, corrige ensuite. La page blanche déteste la perfection.",
    "Le conflit est le moteur : sans tension, pas d'histoire.",
    "Montre, ne raconte pas. Fais vivre la scène au lecteur.",
    "Chaque scène doit changer quelque chose, sinon coupe-la.",
  ],
  dojo: [
    "La Porte du Feu ouvre toutes les autres. Commence par l'élan.",
    "Un sceau par Porte franchie — collectionne les 7.",
    "Discipline d'abord, inspiration ensuite : entraîne-toi chaque jour.",
    "Le Dōjō récompense la régularité, pas la vitesse.",
    "Pose tes questions : la communauté fait grandir l'artisan.",
  ],
};

export function LoaderProvider({ children }) {
  const nav = useNavigate();
  const [state, setState] = useState(null);

  const enterWorld = useCallback((path, opts = {}) => {
    const cat = opts.category || (Math.random() > 0.5 ? "histoire" : "dojo");
    const list = TIPS[cat] || TIPS.histoire;
    const tip = list[Math.floor(Math.random() * list.length)];
    setState({ title: opts.title || "", kanji: opts.kanji || "天", image: opts.image, tip });
    setTimeout(() => nav(path), 1150);
    setTimeout(() => setState(null), 1550);
  }, [nav]);

  return (
    <LoaderCtx.Provider value={{ enterWorld }}>
      {children}
      {state && (
        <div style={s.overlay}>
          {state.image && <div style={{ ...s.bg, backgroundImage: `url(${state.image})` }} />}
          <div style={s.scrim} />
          <div style={s.center}>
            <div style={s.kanji}>{state.kanji}</div>
            {state.title && <div style={s.title}>{state.title}</div>}
            <div style={s.barTrack}><div style={s.barFill} /></div>
          </div>
          <div style={s.tipWrap}>
            <span style={s.tipLabel}>CONSEIL</span>
            <span style={s.tipText}>{state.tip}</span>
          </div>
        </div>
      )}
    </LoaderCtx.Provider>
  );
}

const RED = "#e11d2a";
const s = {
  overlay: { position: "fixed", inset: 0, zIndex: 9999, background: "#0a0a0a", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", overflow: "hidden", animation: "tdFade .25s ease" },
  bg: { position: "absolute", inset: 0, backgroundSize: "cover", backgroundPosition: "center", filter: "blur(14px) brightness(0.5)", transform: "scale(1.1)" },
  scrim: { position: "absolute", inset: 0, background: "radial-gradient(circle at 50% 45%, rgba(10,10,10,0.55), rgba(10,10,10,0.9))" },
  center: { position: "relative", zIndex: 2, textAlign: "center", color: "#fff" },
  kanji: { fontSize: 96, fontWeight: 800, color: RED, textShadow: `0 0 40px ${RED}88`, animation: "tdPulse 1.4s ease-in-out infinite" },
  title: { fontSize: 26, fontWeight: 800, letterSpacing: 2, marginTop: 8, textTransform: "uppercase" },
  barTrack: { width: 240, height: 4, background: "rgba(255,255,255,0.15)", borderRadius: 999, overflow: "hidden", margin: "26px auto 0" },
  barFill: { height: "100%", width: "0%", background: RED, borderRadius: 999, animation: "tdBar 1.3s ease forwards", boxShadow: `0 0 12px ${RED}` },
  tipWrap: { position: "absolute", bottom: 48, left: 0, right: 0, zIndex: 2, textAlign: "center", padding: "0 24px", maxWidth: 640, margin: "0 auto" },
  tipLabel: { display: "block", color: RED, fontWeight: 800, fontSize: 12, letterSpacing: 3, marginBottom: 8 },
  tipText: { color: "rgba(255,255,255,0.9)", fontSize: 15, lineHeight: 1.5, fontStyle: "italic" },
};

if (typeof document !== "undefined" && !document.getElementById("td-loader-kf")) {
  const el = document.createElement("style");
  el.id = "td-loader-kf";
  el.textContent = "@keyframes tdFade{from{opacity:0}to{opacity:1}}@keyframes tdPulse{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.08);opacity:.75}}@keyframes tdBar{from{width:0%}to{width:100%}}";
  document.head.appendChild(el);
}
